import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTargetPerson, useRemoveCart } from 'hooks'
import { WarningModal } from 'packages/eid-ui'
import { Typography, Link, useTheme } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const EmptyCartButton = () => {
    const { t } = useTranslation()
    const theme = useTheme()
    const [targetPerson, setTargetPerson] = useTargetPerson()

    const { mutateAsync: removeCartItems, isLoading: isRemoveCartItems } =
        useRemoveCart(targetPerson.id)

    const [showConfirm, setConfirm] = useState(false)

    const emptyTheCart = () => {
        removeCartItems().then(() => {
            setConfirm(false)
            setTargetPerson(targetPerson)
        })
    }

    return (
        <>
            <Link
                component="button"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '5px',
                    backgroundColor: '#faf7f6',
                    color: theme?.palette?.error?.main,
                    border: '1px solid #ffdacd',
                    minWidth: '100px',
                    minHeight: '48px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    '& svg': {
                        marginLeft: '8px',
                        color: theme?.palette?.error?.main,
                    },
                    '&:hover': {
                        cursor: 'pointer',
                        backgroundColor: theme?.palette?.error?.main,
                        color: theme?.palette?.common?.white,
                        '& svg': {
                            color: theme?.palette?.common?.white,
                        },
                    },
                    transition: 'background-color 0.5s ease',
                }}
                underline="none"
                onClick={() => setConfirm(true)}
            >
                <Typography
                    sx={{
                        fontSize: '16px',
                        fontWeight: 'normal',
                    }}
                >
                    {t('Common_EmptyCart')}
                </Typography>
                <Icon name="Delete" />
            </Link>
            <WarningModal
                title={t('Common_Confirm')}
                description={t('Common_CartResetMessage')}
                yesLabel={t('Common_Yes')}
                noLabel={t('Common_No')}
                open={showConfirm}
                cancel={() => setConfirm(false)}
                proceeding={isRemoveCartItems}
                proceed={emptyTheCart}
            />
        </>
    )
}

export default EmptyCartButton
